var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja"] = require( "front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfile/MemberProfileCreditsInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileCreditsInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileCreditsInner.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileButtonsEdit")) {
var t_7 = t_4.MemberProfileButtonsEdit;
} else {
cb(new Error("cannot import 'MemberProfileButtonsEdit'")); return;
}
context.setVariable("MemberProfileButtonsEdit", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data", "isOwner"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isOwner", Object.prototype.hasOwnProperty.call(kwargs, "isOwner") ? kwargs["isOwner"] : false);var t_9 = "";t_9 += "\n    <div class=\"MemberProfileCreditsInner";
if(runtime.contextOrFrameLookup(context, frame, "isOwner") && (!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"creditsPublic"))) {
t_9 += " hidden";
;
}
t_9 += "\">\n        <div class=\"MemberProfileCreditsInner-title\">\n            Credits\n        </div>\n        <div class=\"MemberProfileCreditsInner-content";
if(!(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits")))) {
t_9 += " isEmpty";
;
}
t_9 += "\">\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner")) {
t_9 += "\n                <div class=\"MemberProfileCreditsInner-contentItem MemberProfileCreditsInner-contentItem--add\">\n                    <div class=\"MemberProfileCreditsInner-contentItem-poster\">\n                        <div class=\"MemberProfileCreditsInner-contentItem-poster-addInfo\">\n                            <div class=\"MemberProfileCreditsInner-contentItem-poster-addIcon\">\n                                <div class=\"MemberProfileCreditsInner-contentItem-poster-addIcon-item\"></div>\n                                <div class=\"MemberProfileCreditsInner-contentItem-poster-addIcon-item\"></div>\n                            </div>\n                            <div class=\"MemberProfileCreditsInner-contentItem-poster-addText\">Add credit</div>\n                        </div>\n                    </div>\n                </div>\n            ";
;
}
t_9 += "\n\n            ";
if(!(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits")))) {
t_9 += "\n                <div class=\"MemberProfileCreditsInner-content-textEmpty\">\n                    <p>You can add any credit by simply copying and pasting the production’s corresponding IMDB link.\n                        We’ll do the rest!</p>\n                </div>\n            ";
;
}
else {
t_9 += "\n                ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                    <div class=\"MemberProfileCreditsInner-contentItem\">\n                        <div class=\"MemberProfileCreditsInner-contentItem-poster\">\n                            <img ";
if(runtime.memberLookup((t_13),"cover")) {
t_9 += "src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"cover")),"w440_url"), env.opts.autoescape);
t_9 += "\"  srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"cover")),"w680_url"), env.opts.autoescape);
t_9 += " 2x\"";
;
}
else {
if(runtime.memberLookup((t_13),"id")) {
t_9 += "src=\"";
t_9 += runtime.suppressValue((lineno = 34, colno = 136, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/no-cover.png"])), env.opts.autoescape);
t_9 += "\"";
;
}
;
}
t_9 += " alt=\"\">\n                        </div>\n                        <div class=\"MemberProfileCreditsInner-contentItem-info\">\n                            <div class=\"MemberProfileCreditsInner-contentItem-infoName\">\n                                ";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"title"), env.opts.autoescape);
t_9 += "\n                            </div>\n                            ";
if(runtime.memberLookup((t_13),"season")) {
t_9 += "\n                                <div class=\"MemberProfileCreditsInner-contentItem-infoSeason\">\n                                    ";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"season"), env.opts.autoescape);
t_9 += "\n                                </div>\n                            ";
;
}
t_9 += "\n                            <div class=\"MemberProfileCreditsInner-contentItem-infoRole\">\n                                ";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"role"), env.opts.autoescape);
t_9 += "\n                            </div>\n                        </div>\n                        ";
if(runtime.memberLookup((t_13),"contributors") && env.getFilter("length").call(context, runtime.memberLookup((t_13),"contributors"))) {
t_9 += "\n                            <div class=\"MemberProfileCreditsInner-contentItem-infoProdMembers\">\n                                <figure>";
t_9 += runtime.suppressValue((lineno = 51, colno = 62, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["menu-user",runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
t_9 += "</figure>\n                                <span>";
t_9 += runtime.suppressValue(env.getFilter("length").call(context, runtime.memberLookup((t_13),"contributors")), env.opts.autoescape);
t_9 += "</span>\n                                <div class=\"MemberProfileCreditsInner-prodMembers\">\n                                    <div class=\"MemberProfileCreditsInner-prodMembersOuter\">\n                                        <div class=\"MemberProfileCreditsInner-prodMembersInner\">\n                                            <div class=\"MemberProfileCreditsInner-prodMembers-title\">\n                                                more production members\n                                            </div>\n                                            <div class=\"MemberProfileCreditsInner-prodMembers-delete\">\n                                                <div class=\"MemberProfileCreditsInner-prodMembers-deleteItem MemberProfileCreditsInner-prodMembers-deleteItem--top\"></div>\n                                                <div class=\"MemberProfileCreditsInner-prodMembers-deleteItem MemberProfileCreditsInner-prodMembers-deleteItem--bottom\"></div>\n                                            </div>\n\n                                            <div class=\"MemberProfileCreditsInner-prodMembersItems\">\n                                                ";
frame = frame.push();
var t_18 = runtime.memberLookup((t_13),"contributors");
if(t_18) {t_18 = runtime.fromIterator(t_18);
var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("member", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
t_9 += "\n                                                    <a href=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_19),"url"), env.opts.autoescape);
t_9 += "\"\n                                                       class=\"MemberProfileCreditsInner-prodMembers-member u-skipUrlParser\">\n                                                        <div class=\"MemberProfileCreditsInner-prodMembers-memberImage ";
if(!runtime.memberLookup((t_19),"userpic")) {
t_9 += "MemberProfileCreditsInner-prodMembers-memberImage--empty";
;
}
t_9 += "\">\n                                                            ";
if(runtime.memberLookup((t_19),"userpic")) {
t_9 += "\n                                                                <img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_19),"userpic")),"w200_url"), env.opts.autoescape);
t_9 += "\"\n                                                                     srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_19),"userpic")),"w400_url"), env.opts.autoescape);
t_9 += " 2x\"\n                                                                     alt=\"\">\n                                                            ";
;
}
else {
t_9 += "\n                                                                <div class=\"MemberProfileCreditsInner-prodMembers-memberImage-initials\">";
t_9 += runtime.suppressValue(runtime.memberLookup((t_19),"initials"), env.opts.autoescape);
t_9 += "</div>\n                                                            ";
;
}
t_9 += "\n                                                        </div>\n                                                        <div class=\"MemberProfileCreditsInner-prodMembers-member-info\">\n                                                            <div class=\"MemberProfileCreditsInner-prodMembers-member-infoName\">\n                                                                ";
t_9 += runtime.suppressValue(runtime.memberLookup((t_19),"fullName"), env.opts.autoescape);
t_9 += "\n                                                            </div>\n                                                            <div class=\"MemberProfileCreditsInner-prodMembers-member-infoRole\">\n                                                                ";
t_9 += runtime.suppressValue(runtime.memberLookup((t_19),"role"), env.opts.autoescape);
t_9 += "\n                                                            </div>\n                                                        </div>\n                                                    </a>\n                                                ";
;
}
}
frame = frame.pop();
t_9 += "\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        ";
;
}
t_9 += "\n                    </div>\n                ";
;
}
}
frame = frame.pop();
t_9 += "\n            ";
;
}
t_9 += "\n        </div>\n    </div>\n\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner")) {
t_9 += "\n        <div class=\"MemberProfileCredits-buttonsEdit\">\n            ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits")))) {
t_9 += "\n                ";
t_9 += runtime.suppressValue((lineno = 103, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileButtonsEdit"), "MemberProfileButtonsEdit", context, [runtime.makeKeywordArgs({"block": "credits","isVisible": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"creditsPublic"),"memberId": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")})])), env.opts.autoescape);
t_9 += "\n";
t_9 += "            ";
;
}
t_9 += "\n        </div>\n    ";
;
}
t_9 += "\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MemberProfileCreditsInner");
context.setVariable("MemberProfileCreditsInner", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfile/MemberProfileCreditsInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileCreditsInner.jinja
// module id = 45
// module chunks = 0